import { Http } from '../../../support';

const initialState = {
  data: [],
  busy: false,
};

const setPartialState = (store, data) => {
  store.setState((state) => {
    state.app.comprobantes.info = {
      ...state.app.comprobantes.info,
      ...data,
    };
  });
};

const info = async (store, id, params = {}) => {
  store.setState((state) => {
    state.app.comprobantes.info.busy = true;
  });

  try {
    const response = await Http.get(`api/comprobantes/${id}`, { params });

    store.setState((state) => {
      state.app.comprobantes.info.busy = false;
      state.app.comprobantes.info.data = response.data;
    });
  } catch (error) {
    store.setState((state) => {
      state.app.comprobantes.info.busy = false;
      state.app.comprobantes.info.error = error.data || error;
    });
  }
};

const reset = (store) => {
  store.setState((state) => {
    state.app.comprobantes.info = { ...initialState };
  });
};

const ComprobanteInfoStore = {
  state: () => initialState,
  actions: {
    setPartialState,
    info,
    reset,
  },
};

export default ComprobanteInfoStore;
